export default "__VITE_ASSET__Cio7ZoVl__"